import React, { useState } from "react";
import { RCCCard } from "react-common-components";
import { Link } from "react-router-dom";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import formatNumber from "src/utils/formatNumber";
import { ICardConfigs } from "../../interface";
import { IDashboardBusinessDiagnosisData } from "./interface";

const BusinessDiagnosisCards: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate, currentLanguage } = useTranslation();
	const [dataBusinessDiagnosis, setDataBusinessDiagnosis] = useState<IDashboardBusinessDiagnosisData>({
		description: "",
		percent: 0
	} as IDashboardBusinessDiagnosisData);


	useEffectFetchData<IDashboardBusinessDiagnosisData> (
		"DashboardBusinessDiagnosis/SelectLastBusinessDiagnosis", 
		{ group: false },
		({ data }) => {
			setDataBusinessDiagnosis(data);
		}
	);

	
	return(
		<Link to={`/diagnostics/${dataBusinessDiagnosis.id && dataBusinessDiagnosis.id !== 0 ? dataBusinessDiagnosis.id : "" }`} style={{ width: "100%" }}>
			<RCCCard
				header={{
					title: card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Card de Diagnóstico de Negócio")
				}}
				body={{
					title: `${dataBusinessDiagnosis.percent !== null ? formatNumber(dataBusinessDiagnosis.percent, currentLanguage) : formatNumber(0, currentLanguage)} %` ,
					text: translate("obtido"),
					icon: {
						name: "thumbs"
					}
				}}
				footer={{
					text: dataBusinessDiagnosis.description !== null ? dataBusinessDiagnosis.description : "" 
				}}
				color="purple"
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				singleColor
			/>
		</Link>
	);};

export default BusinessDiagnosisCards;
